document.addEventListener("DOMContentLoaded", function () {
  const apiKey = "AIzaSyAc_GkZpVRz_a0yd5qLLVyCD-CE_M8Hlr0"; // Replace with your actual API key
  const videos = document.querySelectorAll(".video");
  const players = {}; // Store YouTube players for all videos
  const menuContainer = document.querySelector(".menu-container");
  const menuToggle = document.querySelector(".menu-toggle");
  const menuText = menuToggle.querySelector(".menu-text");
  const menuBlocks = document.querySelector(".menu-blocks");
  const chevronIcon = menuToggle.querySelector(".chevron-icon");
  const accordionTriggers = document.querySelectorAll(".accordion-trigger");

  // Utility function to truncate text at the first sentence-ending punctuation
  function truncateTextAtSentence(text) {
    const match = text.match(/(.*?[.!?])/); // Matches up to the first punctuation
    return match ? match[1] : text; // Returns the matched sentence or full text if no match is found
  }

  // Pause all other videos
  function pauseAllVideos(exceptId) {
    Object.keys(players).forEach((playerId) => {
      if (playerId !== exceptId && players[playerId].pauseVideo) {
        players[playerId].pauseVideo();
      }
    });
  }

  // Initialize YouTube API and fetch video details
  function onYouTubeIframeAPIReady() {
    videos.forEach((video) => {
      const videoId = video.dataset.videoId;
      const titleElement = document.getElementById(`title-${videoId}`);
      const descriptionElement = document.getElementById(`description-${videoId}`);

      // Determine if custom title or description is provided
      const hasCustomTitle = !titleElement;
      const hasCustomDescription = !descriptionElement;

      // Fetch video details from YouTube API if needed
      if (!hasCustomTitle || !hasCustomDescription) {
        fetch(`https://www.googleapis.com/youtube/v3/videos?part=snippet&id=${videoId}&key=${apiKey}`)
          .then((response) => response.json())
          .then((data) => {
            if (data.items && data.items.length > 0) {
              const snippet = data.items[0].snippet;

              // Set the title if not custom
              if (!hasCustomTitle) {
                titleElement.textContent = snippet.title || "Error loading title";
              }

              // Set the description if not custom
              if (!hasCustomDescription) {
                const truncatedDescription = truncateTextAtSentence(snippet.description || "Error loading description");
                descriptionElement.textContent = truncatedDescription;
              }
            } else {
              if (!hasCustomTitle) titleElement.textContent = "Error loading title";
              if (!hasCustomDescription) descriptionElement.textContent = "Error loading description";
            }
          })
          .catch((error) => {
            console.error("Error fetching video data:", error);
            if (!hasCustomTitle) titleElement.textContent = "Error loading title";
            if (!hasCustomDescription) descriptionElement.textContent = "Error loading description";
          });
      }

      // Initialize YouTube Player for each video
      const iframe = document.getElementById(`video-${videoId}`);
      players[videoId] = new YT.Player(iframe, {
        events: {
          onStateChange: function (event) {
            if (event.data === YT.PlayerState.PLAYING) {
              pauseAllVideos(videoId); // Pause all other videos when one starts playing
            }
          },
        },
      });
    });
  }

  // Load YouTube IFrame Player API
  const tag = document.createElement("script");
  tag.src = "https://www.youtube.com/iframe_api";
  const firstScriptTag = document.getElementsByTagName("script")[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  // Make `onYouTubeIframeAPIReady` globally accessible
  window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;

  // Toggle the entire menu visibility
  menuToggle.addEventListener("click", function () {
    const isOpen = menuToggle.getAttribute("aria-expanded") === "true";

    // Update the aria-expanded state
    menuToggle.setAttribute("aria-expanded", !isOpen);

    // Show/hide the menu
    menuBlocks.hidden = isOpen;

    // Update the button text
    menuText.textContent = isOpen ? "Video Categories" : "Hide Video Categories";

    // Rotate the chevron
    chevronIcon.style.transform = isOpen ? "rotate(0deg)" : "rotate(180deg)";

    // Close all inner accordions when the menu is closed
    if (isOpen) {
      accordionTriggers.forEach((trigger) => {
        trigger.setAttribute("aria-expanded", "false");
        trigger.nextElementSibling.classList.remove("open");
      });
    }
  });

  // Handle inner accordion functionality
  accordionTriggers.forEach((trigger) => {
    trigger.addEventListener("click", function () {
      const isOpen = trigger.getAttribute("aria-expanded") === "true";
      const content = trigger.nextElementSibling;

      // Close all other accordions
      accordionTriggers.forEach((otherTrigger) => {
        if (otherTrigger !== trigger) {
          otherTrigger.setAttribute("aria-expanded", "false");
          otherTrigger.nextElementSibling.classList.remove("open");
        }
      });

      // Toggle the current accordion
      trigger.setAttribute("aria-expanded", !isOpen);
      content.classList.toggle("open", !isOpen);
    });
  });

  // Toggle functionality based on screen size
  function checkViewport() {
    if (window.innerWidth <= 749) {
      menuToggle.style.display = "flex"; // Show menu toggle on small screens
      menuBlocks.hidden = true; // Ensure the menu is hidden by default on mobile
    } else {
      menuToggle.style.display = "none"; // Hide menu toggle on larger screens
      menuBlocks.hidden = false; // Always show menu on larger screens
    }
  }

  // Run on load and resize
  checkViewport();
  window.addEventListener("resize", checkViewport);
});
